import { Routes } from "models/routes";
import { menuItems } from "constants/general";

export const routes: Routes = {
  login: {
    path: "/login",
  },
  signup: {
    path: "/signup",
  },
  loginIntro: {
    path: "/welcome-back",
  },
  signupIntro: {
    path: "/welcome",
  },
  // welcome: {
  //   path: "/welcome",
  // },
  tapToStart: {
    path: "tap-to-start",
  },
  home: {
    path: `/${menuItems.HOME.to}`,
  },
  insights: {
    path: `/${menuItems.INSIGHTS.to}`,
  },
  track: {
    path: `/${menuItems.TRACK.to}`,
  },
  explore: {
    path: `/${menuItems.EXPLORE.to}`,
  },
  profile: {
    path: `/${menuItems.PROFILE.to}`,
  },
  logout: {
    path: "/logout",
  },
  termsPrivacy: {
    path: "/conditions-of-use",
  },
  privacyStatement: {
    path: "/privacy-statement",
  },
  notifications: {
    path: "notification",
  },
  authenticate: {
    path: `/authenticate`,
  },
  profileDetails: {
    path: "profile-details",
  },
  exploreAll: {
    path: "all",
  },
  learn: {
    path: "learn",
  },
  learnCategory: {
    path: "learn/:slug",
  },
  products: {
    path: "product",
  },
  slug: {
    path: ":slug",
  },
  articleDetails: {
    path: ":articleId",
  },
  articleDetailsdemo: {
    path: "article-details/:categoryId/:articleId",
  },

  demo: {
    path: "/demo",
  },
  trackSymptom: {
    path: "track-menopause",
  },
  form: {
    path: "/form",
  },
  quickCheckAssessment: {
    path: "quick-check/assessment",
  },
  getGuidance: {
    path: "get-guidance",
  },
  guidanceModule: {
    path: "module",
  },
  trackCalender: {
    path: "track-calender",
  },
  trendsBySign: {
    path: "trends/sign",
  },
  results: {
    path: "quick-check/results",
  },
  guidanceDetails: {
    path: ":articleId",
  },
  contactFormPage: {
    path: "contact-us",
  },
  registrationFlow: {
    path: "onboard/step-one",
  },
  imageUpload: {
    path: "onboard/step-two",
  },
  resetPassword: {
    path: "reset-password",
  },
  changePassword: {
    path: "change-password",
  },
  setNewPassword: {
    path: "set-a-password",
  },
  faq: {
    path: "/frequently-asked-questions",
  },
  aboutUs: {
    path: "about-us",
  },
  country: {
    path: "country",
  },
  productDetails: {
    path: "product/:fieldProductTeaserTitle",
  },
  intro: {
    path: "intro",
  },
};
